import { BenchmarkCategory } from '@/api/generated-catch-backend/model';
import TooltipIcon from '@/app/components/questionnaireV2/icons/tooltip-icon';
import { motion } from 'motion/react';
import { getRiskConfigData } from '../../utils/risk-config';

interface RiskStatusBadgeProps {
  riskLevel: BenchmarkCategory;
  populationAverage: number;
  onBadgeClick?: () => void;
}

export default function RiskStatusBadge({ riskLevel, populationAverage, onBadgeClick }: RiskStatusBadgeProps) {
  const config = getRiskConfigData(riskLevel, 0, populationAverage);
  const isClickable = !!onBadgeClick;

  return (
    <motion.div
      className={`flex items-center justify-center gap-2 rounded-lg px-4 py-2 ${isClickable ? 'hover:bg-[#FFF]' : ''} focus:ring ${config.cssClass}`}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.8 }}
      role="status"
      aria-label={`${riskLevel} risk`}
      aria-describedby={`risk-status-description-${riskLevel}`}
      onClick={onBadgeClick}
    >
      {/* Screen reader description */}
      <div id={`risk-status-description-${riskLevel}`} className="sr-only">
        {config.description}. Population average is {populationAverage}%.
      </div>

      <div className="flex flex-col">
        <span className="body-small text-primary font-semibold" aria-hidden="true">
          {config.text}
        </span>
        <span className="body-small text-primary opacity-80" aria-hidden="true">
          Population Average:
          <span className="body-small text-primary pl-1 font-semibold">{populationAverage}%</span>
        </span>
      </div>
      <button
        className="questionnaire-tooltip-icon"
        aria-label="Show tooltip"
        disabled={!isClickable}
        aria-disabled={!isClickable}
        style={{
          cursor: isClickable ? 'inherit' : 'default',
        }}
      >
        <TooltipIcon />
      </button>
    </motion.div>
  );
}
